import React, {FC, useCallback, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import PromotionAdminForm, { PromoFormData } from '../../../../components/forms/promotions/Promotion.admin.form';
import { IUserState } from '../../../../common/state/profile/user';
import { postPromotionAdmin } from '../../../../common/async/AsyncCalls';
import { getParsedEPOCDate } from '../../../../common/helpers/CommonUtil';
// custom

const PromotionCreateAdmin : FC = () => {
    const history = useHistory();    
    // states    
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    // lifecycle
    const postNewPromotion = useCallback(async(formData: PromoFormData)=>{
        // console.log('Create new promotion record', formData);
        const start_date: number = getParsedEPOCDate(formData.startDate as string)
        const end_date: number = getParsedEPOCDate(formData.endDate as string);
        try {
            await postPromotionAdmin(token, {
                "promo_code": formData.promo_code,
                "description": formData.description,
                "discount": formData.discount,    
                "start_date": start_date,
                "end_date": end_date            
            });
            toast("Promotion record created successfully!");
            history.push({pathname: '/admin/promotions'});
        } catch (err) {
            console.log('Error posting new payment recrod: ', (err as Error).message);
        }
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="w-screen p-4 lg:p-16 min-h-screen bg-gray-200 dark:bg-gray-800
                text-gray-700  dark:text-teal-400 flex flex-col justify-start items-start">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl mb-2">Create New Payment Record</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Please fill out the below form to create a new Payment record. 
                Please note that the fields marked with * are required.                
            </p>
            <PromotionAdminForm defaultFormData={{
                promo_code: '',
                description: '',
                discount: 0,
                startDate: null,
                endDate: null
            }}
            type = 'create' 
            onSubmit={postNewPromotion}/>
        </div>
    </React.Fragment>;
};

export default PromotionCreateAdmin;